import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const SeoHelmet = ({ page, values = {} }) => {
  const { t } = useTranslation();

  const title = t(`helmet.${page}.title`, values);
  const description = t(`helmet.${page}.description`, values);
  const url = values.url || "https://eventbycar.com";
  const image = values.image || "https://eventbycar.com/share.png";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SeoHelmet;
